module.exports = __webpack_public_path__ + "static/img-de-logo-white-ee91fa154c434caf2089bfce71a75b1a.png";